import { Error, Loading } from '@organisms/Feedbacks';
import React from 'react';
import styled from 'styled-components';
import { dateFormat, postCodeFormat } from '../Utils';

type Props = {
    listData:any;
};

const DetailApplicationInfo = (props:Props) => {
    const { listData }=  props;
    const { data, error, loading } = listData;
    
    return (
        <WrapperWithStyled className='detailTableWrapper'>
            {loading && <Loading />}
            {error && <Error />}
            {data &&
                <table className='table table-bordered table-secondary'>
                    <tbody>
                        <tr>
                            <th className='cell-20per'>ID</th>
                            <td className='cell-30per'>{data.id}</td>
                            <th className='cell-20per'>契約ID</th>
                            <td className='cell-30per'>{data.contactId}</td>
                        </tr>
                        <tr>
                            <th>申込種別</th>
                            <td>再点</td>
                            <th>物件管理番号</th>
                            <td>{data.propertyManagementNo}</td>
                        </tr>
                        <tr>
                            <th>入居日</th>
                            <td>{dateFormat(data.moveInDate)}</td>
                            <th>入居依頼日</th>
                            <td>{dateFormat(data.moveInRequestDate)}</td>
                        </tr>
                        <tr>
                            <th>受付工程</th>
                            <td>{data.acceptStatusName}</td>
                            <th>契約者名 カナ</th>
                            <td>{data.contractorNameKana}</td>
                        </tr>
                        <tr>
                            <th>依頼元システム</th>
                            <td>{data.systemClassName}</td>
                            <th>契約者名</th>
                            <td>{data.contractorName}</td>
                        </tr>
                        <tr>
                            <th>電話番号</th>
                            <td colSpan={3}>{data.phoneNumber}</td>
                        </tr>
                        <tr>
                            <th>住所</th>
                            <td colSpan={3}>{postCodeFormat(data.zipCode)}　{data.address}</td>
                        </tr>
                        <tr>
                            <th>供給地点特定番号</th>
                            <td colSpan={3}>
                                {data.powerCustomerLocationNumber}
                                {/* <button className='btn btn-primary btn-sm'>供給地点特定番号登録</button> */}
                            </td>
                        </tr>
                    </tbody>
                </table>
            }
        </WrapperWithStyled>
    );
};

const WrapperWithStyled = styled.div`
    margin: 0 0 10px;
    & td {
        background-color: white;
    }
`

export default DetailApplicationInfo;